import { FundingPFFilters } from "app/utils/types";
import { getHeaderText } from "./projectionSDColumnJson";

export const fundingPFColumnJson: any = (selectedFundingData: any, selectedChartFilter: any) => [
  // Conditionally include selected column only when header is not "Year"
  ...(getHeaderText(selectedChartFilter) !== "Year"
    ? [
        {
          field: selectedChartFilter || "planYear",
          header: getHeaderText(selectedChartFilter),
          frozen: true,
        },
      ]
    : []),
  {
    field: "year",
    header: "Year",
    key: "yearFilter",
  },
  {
    field: "clientPremium",
    header: "Client Premium",
    style: { opacity: !selectedFundingData?.includes(FundingPFFilters.CLIENT_PREMIUM) ? 0.5 : 1 },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "clientPlanFee",
    header: "Plan Fees",
    style: { opacity: !selectedFundingData?.includes(FundingPFFilters.ADMIN_FEES) ? 0.5 : 1 },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "clientInterestPayment",
    header: "Interest Payment",
    style: {
      opacity: !selectedFundingData?.includes(FundingPFFilters.EMPLOYEE_INTEREST_PAYMENT) ? 0.5 : 1,
    },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "clientOriginationFees",
    header: "Origination Fees",
    style: {
      opacity: !selectedFundingData?.includes(FundingPFFilters.PLAN_ORIGINATION_FEES) ? 0.5 : 1,
    },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "lenderPremium",
    header: "Financed Premium",
    style: { opacity: !selectedFundingData?.includes(FundingPFFilters.FINANCED_PREMIUM) ? 0.5 : 1 },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
  {
    field: "lenderOriginationFees",
    header: "Financing Fees",
    // style: {
    //   opacity: !selectedFundingData?.includes(FundingPFFilters.PLAN_ORIGINATION_FEES) ? 0.5 : 1,
    // },
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },

  {
    field: "totalPolicyPremium",
    header: "Total Policy Premium",
    formatter: (value: any) =>
      new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      }).format(value),
  },
];

export const headerColumnGroupFundingPF = {
  "Client Payments": ["Premium", "clientPlanFee", "clientInterestPayment", "clientOriginationFees"],
  "Financed Payments": ["lenderPremium", "lenderOriginationFees"],
  "Total Premium Paid to Insurance Company": ["totalPolicyPremium"],
};
